import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import momentHelper from 'scoreboard/components/moment-helper'
import passwordValidation from 'scoreboard/components/password-validation'
import template from './password-reset.hbs'
import i18n from 'scoreboard/components/i18n'
import user from 'scoreboard/components/user'

var PasswordReset = Backbone.View.extend({

	initialize: function (opt) {
		this.options = opt || {}
	},

	render: function() {
		// $el is set in start.js so set the className manually here
		this.$el.addClass('password-reset')
		this.$('.form-body').html(template(this.context()))
		// This makes no sense here, and won't work so we must hide it
		this.$('.lost-password').addClass('is-not-displayed')
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
		passwordValidation.markFields(this)
		this.formView.start()
		return this
	},

	submit: function() {
		var data = formHelper.readFromDom(this.el)
		data.timezoneOffset = momentHelper.readTimeZoneOffset()
		$.ajax({
			method: 'PUT',
			url: 'api/passwords',
			data: JSON.stringify(data),
			success: function(globals) {
				// #15697 update the user model
				user.model.set('forcePasswordChange', false)
				this.trigger('done', globals)
			}.bind(this),
			error: function(xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	context: function () {
		// #15620 display appropriate message if this is a reset request via email
		var emailReset = this.options && this.options.emailReset
		var messageKey = emailReset ? 'password.emailPasswordChange.message' : 'password.forcePasswordChange.message'
		return {
			message: i18n.get(messageKey)
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields.concat[this.formView], 'remove')
	}
})

export default PasswordReset

PasswordReset.__filename__ = 'components/password-reset.js'
